// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"32830926","453":"9ee5a605","667":"609ce930"}[chunkId] + ".chunk.js";
};